module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "profile"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "user card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.face_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.profile.id))])]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(" " + _vm._s(_vm.profile.user_name) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('i', {
    staticClass: "iconfont role icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.profile.role))]), _vm._v(" "), (_vm.profile.gender == 'm') ? _c('i', {
    staticClass: "iconfont icon-male",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "iconfont icon-female",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.life))]), _vm._v(" "), _c('div', [_vm._v("生命力")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.post_count) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 文章 ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.score) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 积分 ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box"
  }, [_c('div', {
    staticClass: "mail box",
    on: {
      "click": function($event) {
        _vm.$router.push('/reply')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-remind"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 回复我的 ")]), (_vm.profile.new_reply) ? _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v(_vm._s(_vm.profile.new_reply))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "reply box",
    on: {
      "click": function($event) {
        _vm.$router.push('/at')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-at"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 提到我的 ")]), (_vm.profile.new_at) ? _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v(_vm._s(_vm.profile.new_at))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "refer box",
    on: {
      "click": function($event) {
        _vm.$router.push('/mail/inbox')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-email"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 收件箱 ")]), _vm._v(" "), (_vm.profile.new_mail) ? _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v("新")]) : _vm._e(), _vm._v(" "), (_vm.profile.full_mail) ? _c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v("满")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box infomations"
  }, [_c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.$router.push('/post?type=new&board=advice')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-edit"
  }), _vm._v(" \n      "), _c('span', [_vm._v("意见反馈")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.$router.push('/article/id/9272')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-attachment"
  }), _vm._v(" \n      "), _c('span', [_vm._v("论坛管理办法")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.$router.push('/contributor')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-smile"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 特别感谢 ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "box",
    on: {
      "click": _vm.getLogout
    }
  }, [_c('span', [_vm._v(" 退出登录 ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aefcb732","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
// module id = 254
// module chunks = 1